module.exports = __webpack_public_path__ + "img/1602347398.302693ac.png";